import { API_URLS } from '@helpers/api';
import * as React from 'react';
import { useDebounce } from 'react-use';
export function useSuggestions(params) {
    const controller = React.useRef();
    const [data, setData] = React.useState();
    const [searchTerm, setSearchTerm] = React.useState(params.initialValue);
    useDebounce(async () => {
        // Clear existing suggestions.
        setData(undefined);
        // Abort existing fetch if in progress.
        if (controller.current) {
            controller.current.abort();
        }
        // Ignore short terms.
        if (searchTerm.length < 2) {
            return;
        }
        // Create new controller.
        controller.current = new AbortController();
        // Prepare fetch request.
        const params = new URLSearchParams({ searchText: searchTerm });
        const url = `${API_URLS.GET_SUGGESTIONS}?${params.toString()}`;
        // Fetch suggestions.
        const res = await fetch(url, { signal: controller.current.signal });
        const data = (await res.json());
        // Update local state.
        setData(data);
    }, 500, [searchTerm]);
    return { data, searchTerm, setSearchTerm };
}
